import { createContext, useEffect, useReducer } from 'react';
import reducer from '../Functions/FavoriteReducer';


const initState = {
    items: [],
    itemsCounter: 0,
}

export const FavoriteContext = createContext()

const FavoriteContextProvider = ({ children }) => {

    const [state, dispatch] = useReducer(reducer, initState)

    useEffect(() => {
        const storage = JSON.parse(localStorage.getItem("favorite"));
        if (storage) {
            dispatch({
                type: "INIT_STORED_FAVE",
                payload: storage
            });
        }
    }, []);

    return (
        <>
            <FavoriteContext.Provider value={{ state, dispatch }}>
                {children}
            </FavoriteContext.Provider>
        </>
    );
};

export default FavoriteContextProvider;